import { useLiveQuery } from 'dexie-react-hooks'
import { banco } from '../../db/banco'
import { destravar } from '../../sync/outbox'
import { sincronizar } from '../../sync/sincronizador'
import { mensagemHumana } from '../../sync/mensagemHumana'
import { rotuloDoRegistro } from '../../sync/rotuloDoRegistro'

function quando(iso: string | null): string {
  if (!iso) return ''
  return new Date(iso).toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export default function NaoSubiram() {
  // Ao vivo: destravar um registro tira ele da lista sozinho.
  const travados = useLiveQuery(
    async () => {
      const linhas = await banco.outbox.where('travado_em').above('').toArray()
      return linhas.sort((a, b) => (b.travado_em ?? '').localeCompare(a.travado_em ?? ''))
    },
    [],
    undefined,
  )

  async function tentarDeNovo(id: string) {
    await destravar(id)
    await sincronizar()
  }

  // Distinguir "carregando" de "nada travado": senao a tela pisca a mensagem
  // de tudo certo antes de ler o banco.
  if (travados === undefined) {
    return <p className="p-4 text-slate-500">Carregando…</p>
  }

  return (
    <div className="p-4 space-y-3" data-testid="tela-nao-subiram">
      <h1 className="text-lg font-bold text-slate-800">O que não subiu</h1>

      {travados.length === 0 ? (
        <p className="text-slate-600" data-testid="nada-travado">
          Nada travado. Tudo o que você fez chegou no servidor.
        </p>
      ) : (
        <>
          <p className="text-sm text-slate-600">
            O servidor não aceitou estes registros. Eles continuam guardados no aparelho.
          </p>
          <ul className="space-y-3">
            {travados.map((entrada) => {
              const rotulo = rotuloDoRegistro(entrada.tabela, entrada.registro)
              return (
                <li
                  key={entrada.id}
                  data-testid="linha-travada"
                  className="bg-white rounded-xl border border-red-200 p-3 space-y-1"
                >
                  <p className="font-bold text-slate-800">
                    {rotulo.icone} {rotulo.titulo}
                  </p>
                  <p className="text-xs text-slate-500">{quando(entrada.travado_em)}</p>
                  <p className="text-sm text-red-700">
                    {mensagemHumana({ code: entrada.ultimo_codigo ?? undefined })}
                  </p>
                  <button
                    data-testid="tentar-de-novo"
                    onClick={() => void tentarDeNovo(entrada.id)}
                    className="bg-teal-700 text-white rounded-lg px-3 py-1.5 text-sm font-medium"
                  >
                    Tentar de novo
                  </button>
                  <details className="pt-1">
                    <summary
                      data-testid="detalhes-tecnicos"
                      className="text-xs text-slate-500 cursor-pointer"
                    >
                      detalhes técnicos
                    </summary>
                    <p className="text-xs text-slate-600 break-words pt-1">
                      {entrada.tabela} · {entrada.tentativas} tentativas
                      <br />
                      código: {entrada.ultimo_codigo ?? '—'}
                      <br />
                      {entrada.ultimo_erro ?? '—'}
                      <br />
                      id: {entrada.id}
                    </p>
                  </details>
                </li>
              )
            })}
          </ul>
        </>
      )}
    </div>
  )
}
